import { doAction, fetchData } from '@issuu/request';
import type { Request } from 'express';
import type {
    AddToStackRequestBody,
    AddToStackResponse,
    DownloadRequestResponse,
    GetDocumentResponse,
    GetStreamResponse,
    GetTextVersionOfDocumentResponse,
    ToggleLikeDocumentRequestBody,
    ToggleLikeDocumentResponse,
    ToggleSubscribePublisherRequestBody,
    ToggleSubscribePublisherResponse,
} from 'product-document-page-shared';

import type { StreamName } from '../types';

const path = `/call/${BFF_PREFIX}document-page`;

const getAPIPath = (nodeApi?: string) => (nodeApi ? `http://${nodeApi}` : '');

export function getStream(
    stream: StreamName,
    publisherName: string,
    documentName: string,
    nodeApi?: string,
): Promise<GetStreamResponse> {
    return fetchData<GetStreamResponse>(
        `${getAPIPath(nodeApi)}${path}/stream/${stream}/${publisherName}/${documentName}`,
    );
}

export function getTextVersionOfDocument(
    publisherName: string,
    documentName: string,
    nodeApi?: string,
): Promise<GetTextVersionOfDocumentResponse> {
    return fetchData<GetTextVersionOfDocumentResponse>(
        `${getAPIPath(nodeApi)}${path}/text-version/${publisherName}/${documentName}`,
    );
}

export function getDocument(
    publisherName: string,
    documentName: string,
    nodeApi?: string,
    req?: Request,
): Promise<GetDocumentResponse> {
    return fetchData<GetDocumentResponse>(
        `${getAPIPath(nodeApi)}${path}/document/${publisherName}/${documentName}`,
        {
            req,
        },
    );
}

export function toggleLikeDocument(
    publisherName: string,
    documentName: string,
    likeDocument: boolean,
): Promise<ToggleLikeDocumentResponse> {
    const body: ToggleLikeDocumentRequestBody = { likeDocument };
    return doAction<ToggleLikeDocumentResponse>(
        `${path}/document-action/${publisherName}/${documentName}/like`,
        {
            body,
        },
    );
}

export function toggleSubscribePublisher(
    publisherName: string,
    documentName: string,
    subscribePublisher: boolean,
): Promise<ToggleSubscribePublisherResponse> {
    const body: ToggleSubscribePublisherRequestBody = { subscribePublisher };
    return doAction<ToggleSubscribePublisherResponse>(
        `${path}/document-action/${publisherName}/${documentName}/subscribe`,
        {
            body,
        },
    );
}

export function addToStack(
    publisherName: string,
    documentName: string,
    body: AddToStackRequestBody,
): Promise<AddToStackResponse> {
    return doAction<AddToStackResponse>(
        `${path}/document-action/${publisherName}/${documentName}/add-to-stack`,
        {
            body,
        },
    );
}

export function download(
    publisherName: string,
    documentName: string,
): Promise<DownloadRequestResponse> {
    return fetchData<DownloadRequestResponse>(
        `${path}/document-download/${publisherName}/${documentName}`,
    );
}
